import { render } from "./left_line.vue?vue&type=template&id=0bfc2d28"
import script from "./left_line.vue?vue&type=script&lang=js"
export * from "./left_line.vue?vue&type=script&lang=js"
script.render = render

export default script